import React, { useEffect, useState } from 'react';
import { BellIcon, ChevronDownIcon, RadioIcon, SearchIcon, ShipWheelIcon } from 'lucide-react';
type OperationsHeaderProps = {
  query: string;
  onQueryChange: (value: string) => void;
};
export function OperationsHeader({
  query,
  onQueryChange
}: OperationsHeaderProps) {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const timer = window.setInterval(() => setTime(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <header className="sticky top-0 z-40 border-b border-slate-700/80 bg-[#071018]/95 backdrop-blur-md" data-id="element-52">
      <div className="flex min-h-16 items-center gap-3 px-3 sm:px-5" data-id="element-53">
        <div className="flex shrink-0 items-center gap-3 pr-2 lg:border-r lg:border-slate-700/70 lg:pr-5" data-id="element-54">
          <span className="grid h-9 w-9 place-items-center border border-cyan-400/40 bg-cyan-400/5 text-cyan-300" data-id="element-55">
            <ShipWheelIcon className="h-5 w-5" aria-hidden="true" data-id="element-56" />
          </span>
          <div data-id="element-57">
            <p className="font-display text-sm font-bold tracking-[0.16em] text-white" data-id="element-58">
              NEXUS MARITIME
            </p>
            <p className="font-mono text-[9px] tracking-[0.26em] text-slate-500" data-id="element-59">
              GLOBAL COMMAND / 07
            </p>
          </div>
        </div>

        <div className="hidden items-center gap-2 px-2 md:flex" data-id="element-60">
          <span className="relative flex h-2 w-2" data-id="element-61">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-lime-400 opacity-50 motion-reduce:animate-none" data-id="element-62" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-lime-400" data-id="element-63" />
          </span>
          <div data-id="element-64">
            <p className="font-mono text-[10px] font-bold tracking-widest text-lime-300" data-id="element-65">
              NETWORK NOMINAL
            </p>
            <p className="text-[10px] text-slate-500" data-id="element-66">99.982% telemetry</p>
          </div>
        </div>

        <label className="relative ml-auto hidden w-full max-w-xs lg:block" data-id="element-67">
          <span className="sr-only" data-id="element-68">
            Search shipments, vessels, or containers
          </span>
          <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" aria-hidden="true" data-id="element-69" />
          <input value={query} onChange={event => onQueryChange(event.target.value)} className="h-9 w-full border border-slate-700 bg-[#0a151f] pl-9 pr-3 font-mono text-xs text-slate-200 outline-none transition-colors placeholder:text-slate-600 focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400" placeholder="SEARCH ID / VESSEL / ROUTE" data-id="element-70" />
        </label>

        <div className="ml-auto hidden text-right sm:block lg:ml-0" data-id="element-71">
          <p className="font-mono text-sm font-semibold tabular-nums text-cyan-200" data-id="element-72">
            {time.toLocaleTimeString('en-GB', {
            hour12: false,
            timeZone: 'UTC'
          })}
          </p>
          <p className="font-mono text-[9px] tracking-widest text-slate-500" data-id="element-73">
            {time.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            timeZone: 'UTC'
          }).toUpperCase()}{' '}
            UTC
          </p>
        </div>

        <button className="relative grid h-9 w-9 place-items-center border border-slate-700 text-slate-400 transition-colors hover:border-amber-400/60 hover:text-amber-300 focus:outline-none focus:ring-2 focus:ring-cyan-400" aria-label="Notifications, 3 unread" data-id="element-74">
          <BellIcon className="h-4 w-4" data-id="element-75" />
          <span className="absolute right-1 top-1 h-1.5 w-1.5 rounded-full bg-red-400" data-id="element-76" />
        </button>

        <button className="hidden h-9 items-center gap-2 border border-slate-700 px-3 text-left transition-colors hover:border-cyan-400/50 focus:outline-none focus:ring-2 focus:ring-cyan-400 md:flex" aria-label="Open operator menu" data-id="element-77">
          <RadioIcon className="h-4 w-4 text-cyan-400" data-id="element-78" />
          <span data-id="element-79">
            <span className="block text-[10px] font-semibold text-slate-200" data-id="element-80">
              M. OKAFOR
            </span>
            <span className="block font-mono text-[8px] text-slate-500" data-id="element-81">
              SHIFT ALPHA
            </span>
          </span>
          <ChevronDownIcon className="h-3 w-3 text-slate-600" data-id="element-82" />
        </button>
      </div>

      <div className="border-t border-slate-800 px-3 py-2 lg:hidden" data-id="element-83">
        <label className="relative block" data-id="element-84">
          <span className="sr-only" data-id="element-85">
            Search shipments, vessels, or containers
          </span>
          <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" aria-hidden="true" data-id="element-86" />
          <input value={query} onChange={event => onQueryChange(event.target.value)} className="h-9 w-full border border-slate-700 bg-[#0a151f] pl-9 pr-3 font-mono text-xs text-slate-200 outline-none placeholder:text-slate-600 focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400" placeholder="SEARCH ID / VESSEL / ROUTE" data-id="element-87" />
        </label>
      </div>
    </header>;
}